import ListItemIcon from '@mui/material/ListItemIcon';
import EditIcon from '@mui/icons-material/Edit';
import MovingIcon from '@mui/icons-material/Moving';
import HistoryIcon from '@mui/icons-material/History';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import { useTheme } from "@emotion/react";



/**
 * Row action menu options for each customer in the browse DataTable.
 * @returns menu entries (edit, journal entries, history, documents) with icons and hrefs
 */
export function useCustomerOptions() {

    const theme = useTheme();

    return [
        {
            label: "עריכה",
            icon: <ListItemIcon sx={{ color: theme.colors.main_color }}><EditIcon fontSize="small" /></ListItemIcon>,
            href: "",
        },
        {
            label: "תנועות",
            icon: <ListItemIcon sx={{ color: theme.colors.main_color }}><MovingIcon fontSize="small" /></ListItemIcon>,
            href: "journal-entries"
        },
        {
            label: "הסטוריה",
            icon: <ListItemIcon sx={{ color: theme.colors.main_color }}><HistoryIcon fontSize="small" /></ListItemIcon>,
            href: "history"
        },
        {
            label: "מסמכים",
            icon: <ListItemIcon sx={{ color: theme.colors.main_color }}><ContactPageIcon fontSize="small" /></ListItemIcon>,
            href: "documents"
        },
    ];
}
